import React from 'react';
import { Box, Flex, Text, Badge, Divider, Image, Button } from '@chakra-ui/react';
import { Package, Calendar, CheckCircle2 } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
import { useNavigate } from 'react-router-dom';
export const Orders: React.FC = () => {
  const {
    orders,
    adminSettings
  } = useAppContext();
  const navigate = useNavigate();
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Pending':
        return 'orange';
      case 'Confirmed':
        return 'blue';
      case 'Packed':
        return 'purple';
      case 'Out for Delivery':
        return 'teal';
      case 'Delivered':
        return 'green';
      case 'Cancelled':
        return 'red';
      default:
        return 'gray';
    }
  };
  if (orders.length === 0) {
    return <Flex direction="column" align="center" justify="center" minH="70vh" p={4} bg="white" className={adminSettings.animationsEnabled ? 'animate-fade-in' : ''} data-id="element-541">
        <Box className={adminSettings.animationsEnabled ? 'animate-float' : ''} mb={4} data-id="element-542">
          <Box bg="gray.100" p={5} borderRadius="full" data-id="element-543">
            <Package size={48} color="var(--chakra-colors-gray-400)" data-id="element-544" />
          </Box>
        </Box>
        <Text fontSize="lg" fontWeight="700" color="gray.700" data-id="element-545">
          No orders yet
        </Text>
        <Text mt={2} fontSize="sm" color="gray.400" textAlign="center" data-id="element-546">
          Start shopping to see your orders here
        </Text>
        <Button mt={6} bg={adminSettings.accentColor} color="white" borderRadius="12px" px={8} onClick={() => navigate('/products')} data-id="element-547">
          Browse Products
        </Button>
      </Flex>;
  }
  return <Box bg="gray.50" minH="100%" p={3} pb="80px" className={adminSettings.animationsEnabled ? 'animate-fade-in' : ''} data-id="element-548">
      <Text fontSize="lg" fontWeight="700" mb={4} px={1} color="gray.800" data-id="element-549">
        My Orders
      </Text>
      {orders.map((order, idx) => <Box key={order.id} bg="white" p={4} mb={3} borderRadius="14px" shadow="sm" className={adminSettings.animationsEnabled ? 'animate-slide-up' : ''} style={adminSettings.animationsEnabled ? {
      animationDelay: `${idx * 0.05}s`
    } : {}} data-id="element-550">
          <Flex justify="space-between" align="center" mb={3} data-id="element-551">
            <Box data-id="element-552">
              <Text fontSize="10px" color="gray.400" fontWeight="500" data-id="element-553">
                Order ID
              </Text>
              <Text fontSize="sm" fontWeight="700" data-id="element-554">
                {order.id}
              </Text>
            </Box>
            <Badge colorScheme={getStatusColor(order.status)} px={2} py={1} borderRadius="8px" fontSize="10px" fontWeight="600" data-id="element-555">
              {order.status}
            </Badge>
          </Flex>

          <Divider my={2} data-id="element-556" />

          {order.items.map((item, i) => <Flex key={i} py={2} gap={3} align="center" data-id="element-557">
              <Image src={item.images[0]} w="44px" h="44px" objectFit="cover" borderRadius="10px" data-id="element-558" />
              <Box flex={1} data-id="element-559">
                <Text fontSize="xs" fontWeight="600" noOfLines={1} data-id="element-560">
                  {item.title}
                </Text>
                <Text fontSize="10px" color="gray.400" data-id="element-561">
                  Qty: {item.quantity}{' '}
                  {item.selectedSize ? `· ${item.selectedSize}` : ''}
                </Text>
              </Box>
              <Text fontSize="xs" fontWeight="700" data-id="element-562">
                ₹{item.discountPrice * item.quantity}
              </Text>
            </Flex>)}

          <Divider my={2} data-id="element-563" />

          <Box mt={2} mb={2} data-id="element-564">
            {order.status === 'Delivered' && order.deliveryDate ? <Flex align="center" gap={1} color="green.600" data-id="element-565">
                <CheckCircle2 size={14} data-id="element-566" />
                <Text fontSize="xs" fontWeight="600" data-id="element-567">
                  Delivered on {order.deliveryDate}
                </Text>
              </Flex> : order.expectedDeliveryDate ? <Flex align="center" gap={1} color="blue.600" data-id="element-568">
                <Calendar size={14} data-id="element-569" />
                <Text fontSize="xs" fontWeight="600" data-id="element-570">
                  Expected Delivery: {order.expectedDeliveryDate}
                </Text>
              </Flex> : null}
          </Box>

          <Flex justify="space-between" align="center" mt={1} data-id="element-571">
            <Text fontSize="10px" color="gray.400" data-id="element-572">
              Ordered: {order.date}
            </Text>
            <Flex align="center" gap={2} data-id="element-573">
              {order.promoCode && <Badge colorScheme="green" fontSize="8px" data-id="element-574">
                  Promo Applied
                </Badge>}
              <Text fontSize="sm" fontWeight="800" color={adminSettings.accentColor} data-id="element-575">
                ₹{order.total}
              </Text>
            </Flex>
          </Flex>
        </Box>)}
    </Box>;
};